module.exports = __webpack_public_path__ + "static/media/vf-button-earring.d0d5bf06.svg";